import axios from 'axios'
import constants from '../constants/constants'
// TODO fix
// eslint-disable-next-line import/no-cycle
import { fetchData, logOut } from './index'
// eslint-disable-next-line import/no-cycle
import * as actions from './index'
import { FOLLOWING_USER, UNFOLLOWING_USER } from './constants/users'

export const follow =
  ({ userID, viewerID, isFollowing }) =>
  (dispatch) => {
    if (!userID || !viewerID) return

    let successDispatchType = FOLLOWING_USER
    let failureDispatchType = UNFOLLOWING_USER
    let httpVerb = 'POST'

    if (isFollowing) {
      successDispatchType = UNFOLLOWING_USER
      failureDispatchType = FOLLOWING_USER
      httpVerb = 'DELETE'
    }

    dispatch({
      type: successDispatchType,
      viewerID,
      userID
    })

    axios(`${constants.api.users}${userID}/follow`, { method: httpVerb })
      .then((res) => res.data.success)
      .catch((err) => {
        console.error(err)
        dispatch({
          type: failureDispatchType,
          viewerID,
          userID
        })
      })
  }

const fetchAmbassador = (viewerID, influencerID) => (dispatch) => {
  // fetch influencer
  dispatch(
    fetchData({
      path: `${constants.api.ambassadors}influencers/${influencerID}`,
      type: 'ambassadors',
      subtype: 'ambassador'
    })
  )
  // fetch audience
  dispatch(actions.ambassadors.fetchAmbassadorAudience(influencerID))

  // fetch audience reviews
  dispatch(
    actions.reviews.fetchAmbassadorFeedReviews({
      ambassadorID: influencerID,
      isNewSearch: true
    })
  )
  // fetch payments
  dispatch(
    fetchData({
      path: `${constants.api.ambassadors}influencers/${influencerID}/payments`,
      type: 'ambassadors',
      subtype: 'payments'
    })
  )
}

export const fetchViewer = (username) => async (dispatch) => {
  let viewer = {}
  viewer = await dispatch(
    fetchData({
      path: `${constants.api.users}minimal/${username}`,
      type: 'user',
      subtype: 'viewer'
    })
  )
  if (!viewer || !viewer[1]) {
    dispatch(logOut())
    return
  }

  // fetch all influencer related stuff if viewer is an influencer
  if (viewer[1].influencer) {
    dispatch(fetchAmbassador(viewer[1]._id, viewer[1].influencer))
  }
}
